import { Button } from '@/components/ui/button'

interface QueryErrorStateProps {
  message: string
  onRetry: () => void
}

export function QueryErrorState({ message, onRetry }: QueryErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-3 rounded-md border border-dashed p-6"
    >
      <p className="text-sm text-muted-foreground">{message}</p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  )
}
